// extracted by mini-css-extract-plugin
export var subMenu = "Submenu-module--sub-menu--1zBbA";
export var subMenuList = "Submenu-module--sub-menu-list--2QU0W";
export var subMenuListItem = "Submenu-module--sub-menu-list-item--30z4m";
export var subMenuWrapper = "Submenu-module--sub-menu-wrapper--3RpRG";